export default ({
  setEtudiants (state, data) {
    state.etudiants = data
  }
})
